// @flow
import React from 'react'
import { connect } from 'transfer/utils/p2p-connect'
import SendAmountField from '../send-amount-field'
import ForeignExchangeCalculator from '../foreignExchangeCalculator'
import { FLOW_TYPES } from '../../constants'

type Props = {
  isCrossCurrency: boolean,
  hasFetchedFundingOptions: boolean,
  isReview: boolean,
  payRequestAmount: any,
  disableAmountField: boolean,
  isLoading: boolean,
  isMgm: boolean,
  isRecipientCurrencyRestricted: boolean,
  isPpshops: Boolean,
}
export function ConvertibleAmountField({
  isCrossCurrency,
  hasFetchedFundingOptions,
  isReview,
  isLoading,
  payRequestAmount = false,
  isMgm,
  isRecipientCurrencyRestricted,
  isPpshops,
}: Props) {
  return isCrossCurrency && !hasFetchedFundingOptions ? (
    <ForeignExchangeCalculator
      isReview={isReview}
      disableAmountField={isLoading}
      isRecipientCurrencyRestricted={isRecipientCurrencyRestricted}
    />
  ) : (
    <SendAmountField
      shouldFocusAmountField={!isCrossCurrency}
      isAmountReadOnly={
        isCrossCurrency || !!payRequestAmount || isMgm || isPpshops
      }
      isReview={isReview && !isPpshops}
      isCurrencyCodeReadOnly={!!payRequestAmount || isPpshops}
      payRequestAmount={payRequestAmount ? payRequestAmount : undefined}
      disableAmountField={isLoading || isMgm}
    />
  )
}

export default connect(
  ({ crossBorder, transaction, loading, server, recipient }) => ({
    isCrossCurrency:
      crossBorder.fromCurrencyCode !== crossBorder.toCurrencyCode,
    hasFetchedFundingOptions: transaction.hasFetchedFundingOptions,
    isLoading: Boolean(loading.isLoading),
    isMgm: server.isMgm,
    isRecipientCurrencyRestricted: Boolean(
      recipient.isRecipientCurrencyRestricted
    ),
    isPpshops: server.env === FLOW_TYPES.PPSHOPS,
  })
)(ConvertibleAmountField)
